// Global CSS classes
enum GlobalClass {
  ButtonPlain = "buttonPlain",
  GradientBg = "gradientBg",
  HideText = "hideText",
  PixelArtImage = "pixelArtImage",
}

export default GlobalClass;
